module.exports = __webpack_public_path__ + "static/w3c_wcag_aa-6622039472224fd3f3a23ed227a8f644.png";